module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/tables_en-12103d954bb8ac96903e91f899ecddaf.png";